import firebase from "firebase/app";
import "firebase/functions";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import axios from "axios";

var firebaseConfig = {
  apiKey: "AIzaSyD37jZmd_CQ9wEGgYaLaK4T2hrphsCUlxE",
  authDomain: "imperia-innovation.firebaseapp.com",
  databaseURL: "https://imperia-innovation.firebaseio.com",
  projectId: "imperia-innovation",
  storageBucket: "imperia-innovation.appspot.com",
  messagingSenderId: "844960278698",
  appId: "1:844960278698:web:de08009e9c6ac8174e08d3"
};

firebase.initializeApp(firebaseConfig);
const functions = firebase.functions();
/*
if (location.hostname === "localhost") {
	functions.useFunctionsEmulator("http://localhost:5001");
}
*/
const auth = firebase.auth();
const storage = firebase.storage();
const firestore = firebase.firestore();

export const api = functionName => async body => {
  /*
  const url =
    location.hostname === "localhost"
      ? "http://localhost:5001/imperia-innovation/us-central1/api"
      : "https://us-central1-imperia-innovation.cloudfunctions.net/api";
      */
  const url = "https://us-central1-imperia-innovation.cloudfunctions.net/api";
  const { data } = await axios.post(`${url}/${functionName}`, body);
  
  return data;
};

export { functions, auth, firestore, storage };



// WEBPACK FOOTER //
// ./src/firebase.js